import request from "./index"

export declare type PaymentMode = "contract" | "address" | "mix"

export enum orderStatus {
    "TO-BE-PAID" = "TO-BE-PAID",
    "VERIFYING" = "VERIFYING",
    "PAID" = "PAID",
    "TIME-OUT" = "TIME-OUT",
    "CLOSE" = "CLOSE",
    "REFUND-IN-PROGRESS" = "REFUND-IN-PROGRESS",
    "REFUNDED" = "REFUNDED",
    "ABNORMAL" = "ABNORMAL",
    "CHAIN-CONFIRMATION-FAILED" = "CHAIN-CONFIRMATION-FAILED"
}

export declare interface Order {
    out_trade_no: string
    fiat_name: string
    fiat_amount: string
    status: orderStatus
    amount: string
    chain: string
    chain_id: number
    contract: string
    decimal: number
    mode: PaymentMode
    pay_address: string
    time_expire: number
    token: string
    trade_no: string
    equity: number
    contract_pay_address: string
    create_time: number
    need_confirms: number
    already_confirms: number
    chain_info: {
        abi: string
        browser_url: string
        decimal: number
        rpc: string
        token: string
    }
}

export declare interface Goods {
    amount: string
    image: string
    name: string
    app_name: string
    app_icon: string
    status: string
    symbol: string
    transaction?: Order
    upi_account?: string
    upi_name?: string
}

export interface ChainItem {
    id: number
    chain: string
    check: boolean
    contract: string
    decimal: number
    logo: string
    protocol: string
    service_charge: string
    token: string
    token_full_name: string
    subset?: (ChainItem & {currency_id: string})[]
}

export interface Amount {
    amount: string
    exchange_rate: string
}

export const requests = {
    order() {
        return request.get<Order>(
            "/v1/entrust"
        )
    },
    pay(currency_id: string) {
        return request.post<Order>(
            "/v1/entrust/pay",
            {
                currency_id
            }
        )
    },
    amount(currency_ids: string[]) {
        return request.post<Record<string, Amount>>(
            "/v1/entrust/amount",
            {
                currency_id: currency_ids
            }
        )
    },
    currency() {
        return request.get<ChainItem[]>(
            "/v1/entrust/currency"
        )
    },
    goods() {
        return request.get<Goods>(
            "/v1/entrust/goods"
        )
    },
    version() {
        return request.get<number>(
            "/api/system/version",
            {
                sysid: "G4AY8GAdtdXoGzN9A2GbuaZn2t4t3dxfCBNmzHbPjJjU"
            }
        )
    }
}

export default requests
